import React from 'react';
export const DossierContext = React.createContext({
    dossier: null,
    setDossier: () => { },
    refresh: () => { },
    loading: false,
    error: false,
    userHasSecurityToken: false
});
export const useDossierContext = () => React.useContext(DossierContext);
